import { useAuthContext } from '../context/AuthContext';

// Convenience hook for components.
export function useAuth() {
  return useAuthContext();
}
